/* eslint-disable react/jsx-sort-props,react/jsx-no-bind */
import React, { useCallback, useState } from "react";

import {
    authService,
    moderatorService,
    workspaceService
} from "../../../../service";
import { getRoomName } from "../../base/conference";
import { translate } from "../../base/i18n";
import { openSubscriptionModal as openSubscriptionAction, openForgotPassModal as openForgotPassModalAction } from "../actions";
import { IconAccountLogin, IconLogoComrex } from "../../base/icons";
import { ActionButton, InputField } from "../../base/premeeting";
import Footer from "../../base/premeeting/components/web/Footer";
import Preview from "../../base/premeeting/components/web/Preview";
import { connect } from "../../base/redux";
import { getDisplayName, updateSettings } from "../../base/settings";
import LoginForm from "./LoginForm";
import { useNextInput } from "../useNextInput";
import ForgotPassDialog from "./forgot-dialog/web/ForgotPassDialog";

const emailRegx = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
const EXPIRED_MSG = 'EXPIRED_ACCOUNT'
const WelcomeScreen = (props) => {
    const { t, updateSettings, openSubscriptionModal, _username } = props;
    const [username, setUsername] = useState(_username);
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [formType, setFormType] = useState('login');
    const [errorMessage, setErrorMessage] = useState("");
    const [isSubmitSuccess, setSubmitSuccess] = useState(false);
    const [error, setError] = useState({
        username: "",
        password: "",
        email: ""
    });
    const { registerInput } = useNextInput();

    const { DISPLAY_WELCOME_FOOTER } = interfaceConfig;

    const getContentClassName = () => {
        const showAdditionalContent =
            interfaceConfig.DISPLAY_WELCOME_PAGE_CONTENT &&
            this._additionalContentTemplate &&
            this._additionalContentTemplate.content &&
            this._additionalContentTemplate.innerHTML.trim();

        return showAdditionalContent ? "with-content" : "without-content";
    };

    const contentClassName = getContentClassName();
    const footerClassName = DISPLAY_WELCOME_FOOTER
        ? "with-footer"
        : "without-footer";

    const doForgotPass = useCallback(() => {
        setFormType('forgot')
    }, []);

    const submitEmail = useCallback(() => {
        if(email === '') {
            setError({
                ...error,
                email: "* Email is required"
            });
        } else if(!emailRegx.test(email)) {
            setError({
                ...error,
                email: "* Check the format of the email you entered"
            });
        } else if(email.length > 80) {
            setError({
                ...error,
                email: "* Maximum length is 80 characters"
            });
        } else {
            setError({
                ...error,
                email: ""
            });
            authService.requestResetPass(email)
            .then(resp => {
                    if(resp.data.success) {
                        setSubmitSuccess(true)
                    }
                })
                .catch(err => {
                    setErrorMessage(err?.response?.data?.message);
                })
        }
    }, [email]);

    const renderErrorMsg = useCallback(() => {
        if(errorMessage === EXPIRED_MSG) {
            return <>Account is inactive. Please click <a href="https://www.comrex.com/products/gagl/">&nbsp;here&nbsp;</a> to reactivate your account.</>
        }
        return t(errorMessage) || ""
    }, [errorMessage])

    const _onFormSubmit = async () => {
        setError({
            ...error,
            username: username.trim() ? "" : t("login.username_require"),
            password: password.trim() ? "" : t("login.password_require"),
        });
        const isLoginWithEmail = emailRegx.test(username)
        const payload = {
            email: isLoginWithEmail ? username : undefined,
            username: isLoginWithEmail ? undefined : username,
            password
        }
        let user
        if (username.trim() && password.trim()) {
            try {
                const response = await authService.login(payload)
                let data = response?.data;
                localStorage.setItem('auth_token', data.accessToken);
                localStorage.setItem('refreshToken', data.refreshToken);
                user = data.user;
                let workspace = null
                if(user?.workspaceId) {
                    const { data: workspaceRes } = await workspaceService.getCurrent()
                    workspace = workspaceRes.workspace
                }
                const { data: configurationData } = await moderatorService.getConfiguration()
                user.codec_ip = configurationData?.configuration?.codec_ip;
                user.codec_name = configurationData?.configuration?.codec_name;
                updateSettings({
                    user,
                    workspace
                });
            } catch(error) {
                console.log({error})
                if(error.response?.data?.message === 'INVALID_SUBSCRIPTION') {
                    openSubscriptionModal();
                    return
                }
                if(error.response?.data?.message === EXPIRED_MSG) {
                    setErrorMessage(EXPIRED_MSG);
                    return
                }
                console.log('login error')
                setErrorMessage(error?.response?.data?.message || 'Internal server error');
            };

        }
    };

    return (
        <>
            <div
                className={`welcome ${contentClassName} ${footerClassName}`}
                id="welcome_page"
            >
                {/* <div className = 'welcome-watermark'>*/}
                {/* <Watermarks defaultJitsiLogoURL = { DEFAULT_WELCOME_PAGE_LOGO_URL } />*/}
                {/* </div>*/}
                <Preview />

                <div className="content welcome-screen">
                    <div className="content-body content-body-500 content-body-welcome-screen height-100">
                        <div style={{ width: "100%" }}>
                            <div className="flex-row jus-between login-form-500" style={{alignItems: 'center'}}>
                                <div>
                                    <a href='https://www.comrex.com/' target={'_blank'}>
                                        <IconLogoComrex
                                            className={"comrex-icon-500"}
                                            height="40px"
                                        />
                                    </a>
                                </div>
                                <div>
                                    <img
                                        className={"gagl-logo"}
                                        src="./images/gagl.png"
                                    />
                                </div>
                            </div>
                            <div
                                className="prejoin-input-area-container login-form-500"
                                style={{
                                    backgroundColor: "white",
                                    marginTop: 25,
                                    borderRadius: 16,
                                    boxShadow: "1px 1px 2px 1px rgb(0 0 0 / 25%)",
                                }}
                            >
                                <div
                                    className={"login-form-header-100"}
                                    style={{
                                        height: 140,
                                        width: "100%",
                                        backgroundColor: "#9eb7ca",
                                        position: "relative",
                                        borderTopLeftRadius: 10,
                                        borderTopRightRadius: 10,
                                    }}
                                >
                                    <div
                                        style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <img
                                            width="92%"
                                            height="100%"
                                            src="./images/account-background.png"
                                        />
                                    </div>
                                    <div
                                        style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <IconAccountLogin height="100%" />
                                    </div>
                                </div>
                                <div className="prejoin-input-area welcome-input-side padding-350">
                                    {formType === 'login' && (
                                        <>
                                            <LoginForm
                                                onSubmit={_onFormSubmit}
                                                setUsername={setUsername}
                                                setPassword={setPassword}
                                                setError={setError}
                                                error={error}
                                                renderErrorMsg={renderErrorMsg}
                                            />
                                        </>
                                    )}
                                    {formType === 'forgot' && (
                                        <>
                                            <div style={{ width: "100%", height: 45 }}>
                                                <InputField
                                                    ref={registerInput}
                                                    autoFocus={true}
                                                    onChange={(value) => {
                                                        setEmail(value);
                                                        setError({
                                                            ...error,
                                                            email: "",
                                                        });
                                                    }}
                                                    value={email}
                                                    placeHolder={t("login.email")}
                                                />
                                                <p
                                                    style={{
                                                        color: "red",
                                                        display: "flex",
                                                    }}
                                                >
                                                    {error.email}
                                                </p>
                                            </div>
                                            <div style={{ marginTop: 30 }}>
                                                <ActionButton
                                                    ref={registerInput}
                                                    className="button-login"
                                                    onClick={() => submitEmail()}
                                                    type="primary"
                                                >
                                                    {t("login.submit")}
                                                </ActionButton>
                                                <p
                                                    style={{
                                                        color: "red",
                                                        marginTop: 10,
                                                        display: "flex",
                                                    }}
                                                >
                                                    {errorMessage ? t(errorMessage) : ""}
                                                </p>
                                            </div>
                                        </>
                                    )}

                                </div>
                            </div>
                            <div
                                className={
                                    "welcome-input-footer welcome-screen-input-footer"
                                }
                            >
                                {formType === 'login' ?
                                    <div
                                        style={{
                                            fontSize: 16,
                                            color: "#777777",
                                            textAlign: "center",
                                            //fontFamily: "roboto",
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => doForgotPass()}
                                    >
                                        {t("login.forgotYourPassword")}
                                    </div>
                                    :
                                    <div
                                        style={{
                                            fontSize: 16,
                                            color: "#777777",
                                            textAlign: "center",
                                            //fontFamily: "roboto",
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => setFormType('login')}
                                    >
                                        {t("login.signIn")}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={"footer-welcome-screen z-index-1"}>
                        <Footer />
                    </div>
                </div>
            </div>
            {isSubmitSuccess && <ForgotPassDialog onCancel={() => setSubmitSuccess(false)}/>}
        </>
    );
};

function mapStateToProps(state, ownProps) {
    const name = getDisplayName(state);
    const username = window.location.search !== undefined ? window.location.search.replace('?username=', '') : "" || "";

    return {
        name,
        roomName: getRoomName(state),
        _username: username
    };
}

const mapDispatchToProps = {
    updateSettings,
    openSubscriptionModal: openSubscriptionAction,
    openForgotPassModal: openForgotPassModalAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(translate(WelcomeScreen));
